export const HERO_IMAGE =
  'https://img.uswitch.com/n36b8lzdmgnp/4VezQ7YgZCOoRxN2rDR2Zt/ce3a201dcabd7ea325647d6118e30706/People-2023-Aiden-Pleased-Watermelon.png'

export const HERO_IMAGE_LARGE =
  'https://img.uswitch.com/n36b8lzdmgnp/4VezQ7YgZCOoRxN2rDR2Zt/ce3a201dcabd7ea325647d6118e30706/People-2023-Aiden-Pleased-Watermelon.png'

export const BLACK_FRIDAY_HOMEPAGE_HERO_IMAGE =
  'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/black-friday-homepage-hero-stickers.svg'

export const BLACK_FRIDAY_PACKAGES_HERO_MOBILE_IMAGE =
  'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/black-friday-broadband-packages-hero-stickers-mobile.svg'

export const BLACK_FRIDAY_PACKAGES_HERO_P0_LEFT_IMAGE =
  'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/black-friday-broadband-packages-hero-stickers-p0-left.svg'

export const BLACK_FRIDAY_PACKAGES_HERO_P0_RIGHT_IMAGE =
  'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/black-friday-broadband-packages-hero-stickers-p0-right.svg'

export const BLACK_FRIDAY_PAGE_HERO_P0_LEFT_IMAGE =
  'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/black-friday-broadband-page-hero-stickers-p0-left.svg'

export const BLACK_FRIDAY_PAGE_HERO_P0_RIGHT_IMAGE =
  'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/black-friday-broadband-page-hero-stickers-p0-right.svg'

export const BLACK_FRIDAY_NAVIGATION_MODULE_IMAGE =
  'https://img.uswitch.com/s3/uswitch-assets-eu/broadband/images/black-friday-broadband-navigation-sticker.svg'

export const DEFAULT_HOMEPAGE_HERO_IMAGE =
  'https://images.ctfassets.net/g836doytpz4a/4x3LTsq7Q6jNFGNri9IMnD/45bf455a539efb6647cb8d3e78cfa162/sanjay_uswitch_broadband.png'
